export const PhoneSVG = (props: {
    className?: string;
    'data-testid'?: string;
}) => (
    <svg
        className={props.className}
        data-testid={props['data-testid']}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M19.241 15.048L16.0633 11.8524C15.5825 11.3682 14.7998 11.3682 14.3178 11.8499L11.4938 14.6723L5.33052 8.51262L8.15824 5.68656C8.63897 5.20611 8.64021 4.42629 8.15947 3.94461L4.97922 0.761289C4.49725 0.279603 3.71698 0.279603 3.23501 0.761289L0.404833 3.58858L0.399902 3.58488C0.399902 12.4302 7.57396 19.6 16.4244 19.6L19.2386 16.7875C19.7193 16.3071 19.7205 15.5297 19.241 15.048Z" />
    </svg>
);
